import { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import PlotWaypoint from './PlotWaypoint';
import ErrorSnackBar from '@/components/shared/ErrorSnackBar';
import PLOT_STATUSES from '../../../../plotStatuses';
import type { PlotWaypoint as PlotWaypointType } from '@/types';

interface PlotMarkersProps {
  plotId: string | undefined;
  waypoints: PlotWaypointType[];
  plotStatus?: string;
  onMarkersChange: () => void | Promise<void>;
}

function PlotMarkers({
  plotId,
  waypoints,
  plotStatus,
  onMarkersChange,
}: PlotMarkersProps): React.JSX.Element {
  const [api_error, setApiError] = useState<string | null>(null);
  const [expanded, setExpanded] = useState<boolean>(
    plotStatus === PLOT_STATUSES.DRAFT,
  );

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      disabled={false}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='plot-markers-content'
        id='plot-markers-header'
      >
        <Typography
          variant='h6'
          sx={{
            fontWeight: 'bold',
            color: 'primary.main',
          }}
        >
          Plot Markers
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <Divider sx={{ mb: 2 }} />
          {!waypoints || waypoints.length === 0 ? (
            <Typography variant='body2' color='text.secondary'>
              No waypoints found for this plot.
            </Typography>
          ) : (
            waypoints.map((waypoint, index) => (
              <PlotWaypoint
                key={waypoint.entity_id || index}
                waypoint={waypoint}
                plotId={plotId}
                plotStatus={plotStatus}
                onMarkersChange={onMarkersChange}
              />
            ))
          )}
        </Box>
      </AccordionDetails>
      <ErrorSnackBar message={api_error} onClear={() => setApiError(null)} />
    </Accordion>
  );
}

export default PlotMarkers;

